export default __webpack_public_path__ + "static/media/5250.61166dec.png";